/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC } from 'react';
import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { tableFilters } from './tableFilters';
import { ContainerRelease } from '../../types';

export type ParsedContainerRelease = Omit<
  ContainerRelease,
  'tipoContenedor' & 'cierreStacking'
> & {
  tipo?: string;
  tamano?: string;
  numero?: string;
};

type ContainerRealaseProps = {
  data?: ParsedContainerRelease[];
  isLoading?: boolean;
  selectedItems: any[];
  handleSelectionChange: (e: { value: any }) => void;
};

const ContainerRealase: FC<ContainerRealaseProps> = ({
  data,
  isLoading,
  selectedItems,
  handleSelectionChange,
}) => {
  const tableColumns = getTableColumns(data);

  return (
    <Table
      columns={tableColumns}
      data={data}
      isLoading={isLoading}
      filters={tableFilters}
      filterDisplay="menu"
      paginator
      rows={10}
      autoRowsToFillViewport
      selectableColumns
      selectionId="numero"
      selectedItems={selectedItems}
      onSelectionChange={handleSelectionChange}
    />
  );
};

export default ContainerRealase;
